// test2886
(2886 && 0);
